import { useMemo } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";

function formatSlugToTitle(slug: string): string {
  return slug
    .trim()
    .replace(/[_-]+/g, " ")
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export default function UnsubscribeSuccess() {
  const [searchParams] = useSearchParams();
  const category = searchParams.get("category") || "";

  const categoryLabel = useMemo(() => {
    if (!category) return "";
    return formatSlugToTitle(category);
  }, [category]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 h-14 w-14 rounded-full bg-primary/10 flex items-center justify-center">
            <CheckCircle className="h-7 w-7 text-primary" />
          </div>
          <CardTitle className="text-2xl">Unsubscribe Confirmed</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-6">
          <p className="text-muted-foreground">
            You will no longer receive{" "}
            <span className="font-semibold text-foreground">
              {categoryLabel || category}
            </span>{" "}
            by email.
          </p>

          <Button asChild className="w-full">
            <Link to="/">Back to Home</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
